<template>
    <div>
        <v-row class="header ml-0 mr-0">
            <v-row class="pl-5">
                <v-col class="white--text text-body-2" cols="1">
                    <span class="font-weight-bold">Código</span>
                    <p class="mb-0">{{ajuste.codigo}}</p>
                </v-col>
                <v-col class="white--text text-body-2" cols="1">
                    <span class="font-weight-bold">Finalizado por</span>
                    <p class="mb-0">{{ajuste.usuarioFinalizacao}}</p>
                </v-col>
                <v-col class="white--text text-body-2" cols="1">
                    <span class="font-weight-bold">Finalizado em</span>
                    <p class="mb-0">{{ajuste.dataFinalizacao | azDate()}}</p>
                </v-col>
                <v-col class="white--text text-body-2" cols="1">
                    <span class="font-weight-bold">Situação</span>
                    <p class="mb-0">{{ajuste.situacao | azEnum(situacoesAjuste)}}</p>
                </v-col>
            </v-row>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: 'AjusteDetalheCabecalho',
        props: ['ajuste']
    }
</script>
